import { createAsyncThunk } from '@reduxjs/toolkit'
import { SippApi } from '../../../services/SippExpress'

// SIPP-611: fire WQI Report Completed event to Klaviyo + Customer.io
// Backend checks klaviyoEventsFired before firing to prevent duplicates.

interface FireWqiReportCompletedParams {
  userId: string
  wqiScore: number
  wqiBand: string
  topParameter: string
  utilityName: string
}

export const fireWqiReportCompletedAsync = createAsyncThunk<
  void,
  FireWqiReportCompletedParams
>(
  'waterQualityIndex/fireWqiReportCompleted',
  async ({ userId, wqiScore, wqiBand, topParameter, utilityName }, { rejectWithValue }) => {
    try {
      await SippApi.create.wqiReportCompleted(userId, {
        wqiScore,
        wqiBand,
        topParameter,
        utilityName,
      })
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || { message: 'Unexpected error occurred' })
    }
  }
)
